__turbopack_context__.v({
  "SearchResultContainer": "_DMQda_SearchResultContainer",
});
